module.exports = __webpack_public_path__ + "static/media/google_12.39708790.svg";